<template>
  <div class="box vux-1px-b">
    <img :src="icons" alt="" />
    <h5>
      <span>{{ name }}</span>
      <slot name="centent"></slot>
    </h5>

    <i class="icon iconfont icon-enter"></i>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    icons: {
      default:
        'http://cdn.yxvzb.com/newWechat/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E6%88%91%E7%9A%84%E7%A7%AF%E5%88%86%20@2x.png'
    },
    name: {
      default: '我的积分'
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
@import '../../../public/style/g.less';

.box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.4rem;
  padding-bottom: 0.4rem;
  /*border-bottom: 1px solid #EBEBEB;*/

  img {
    width: 0.4533rem;
    height: 0.4533rem;
    margin-right: 0.4rem;
  }
  h5 {
    font-size: 0.3733rem;
    flex: 3;
    display: flex;
    align-items: center;
  }
  i {
    /*position: absolute;*/
    /*right:0;*/
  }
}
</style>
